import { z } from "zod";

const noteUserSchema = z.object({
  id: z.guid(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
});

export const noteRowSchema = z.object({
  id: z.guid(),
  workspace_id: z.guid(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
  content: z.string().nullable(),
  title: z.string().nullable(),
  summarized_content: z.string().nullable(),
  audio_transcription: z.string().nullable(),
  created_by: noteUserSchema.nullable(),
  updated_by: noteUserSchema.nullable(),
  talent_id: z.guid().nullable(),
  company_id: z.guid().nullable(),
  contact_id: z.guid().nullable(),
  mission_id: z.guid().nullable(),
  contract_id: z.guid().nullable(),
  medical_checkup_request_id: z.guid().nullable(),
  qualification_training_request_id: z.guid().nullable(),
  onboarding_request_id: z.guid().nullable(),
  is_service_note: z.boolean().nullable(),
  is_feedback_positive: z.boolean().nullable(),
  feedback: z.string().nullable(),
  call_id: z.guid().nullable(),
  type: z.enum(["manual", "vocal", "generated"]),
});

export const noteListQuerySchema = z.object({
  talent_id: z.guid().optional(),
  company_id: z.guid().optional(),
  contact_id: z.guid().optional(),
  mission_id: z.guid().optional(),
  contract_id: z.guid().optional(),
  medical_checkup_request_id: z.guid().optional(),
  qualification_training_request_id: z.guid().optional(),
  onboarding_request_id: z.guid().optional(),
  contract_ids: z
    .preprocess((val) => (typeof val === "string" ? val.split(",").filter(Boolean) : val), z.array(z.guid()))
    .optional(),
});

export const noteCreateBodySchema = z.object({
  workspace_id: z.guid(),
  content: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  audio_transcription: z.string().nullable().optional(),
  talent_id: z.guid().nullable().optional(),
  company_id: z.guid().nullable().optional(),
  contact_id: z.guid().nullable().optional(),
  mission_id: z.guid().nullable().optional(),
  contract_id: z.guid().nullable().optional(),
  medical_checkup_request_id: z.guid().nullable().optional(),
  qualification_training_request_id: z.guid().nullable().optional(),
  onboarding_request_id: z.guid().nullable().optional(),
  is_feedback_positive: z.boolean().nullable().optional(),
  feedback: z.string().nullable().optional(),
  call_id: z.guid().nullable().optional(),
});

export const noteUpdateBodySchema = z.object({
  content: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  audio_transcription: z.string().nullable().optional(),
  summarized_content: z.string().nullable().optional(),
  is_feedback_positive: z.boolean().nullable().optional(),
  feedback: z.string().nullable().optional(),
});

export type Note = z.infer<typeof noteRowSchema>;
export type NoteListQuery = z.infer<typeof noteListQuerySchema>;
export type NoteCreateBody = z.infer<typeof noteCreateBodySchema>;
export type NoteUpdateBody = z.infer<typeof noteUpdateBodySchema>;
